import React, {Component, useState, useEffect} from 'react'
import {Button, Container, Row, Col, FormLabel, FormControl} from 'react-bootstrap';
import JobDataService from "./services/job.service";
import FastQuotingDoorDataService from './services/fastquotingdoor.service.js';
import FastQuotingDoorVersionsDataService from './services/fastquotingdoorversions.service';
import VersionDoorDetailDataService from './services/versiondoordetail.service.js';
import DoorsList from './DoorsList';
import NewEditDoor from './NewEditDoor.js'
import MessageBox from './MessageBox';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { doorstyles, producttypes } from './AuxiliaryFunctions';

import MaterialBrandsDataService from './services/materialbrand.service';
import MaterialColorsDataService from './services/materialcolor.service';

import { usdCurrencyFormat } from "./numberFormats";
import SearchJob from './SearchJob';
import { dtFormatter, dtForInputDate, PageHeader, getUserRoles } from './AuxiliaryFunctions';
import { useParams } from "react-router-dom";
 import { useNavigate } from 'react-router-dom';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear();
var dtDate = newDate.getFullYear() + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getDate().toString().padStart(2,'0');

function transformArray(arr1) {
  /*
    id: idSelVal,
    partnumber: otherVal3,
    description: descSelVal,
    uom: otherVal,
    uomId: otherVal4,
    cost: otherVal2,
    itmqty: null  
  */

  return arr1.map(obj => {
    return { 
      id:obj.item.id,
      partnumber: obj.item.itempartnumber,
      description: obj.item.itemdescription, 
      uom: obj.item.primaryuom.unitofmeasureabbrev,
      uomId: obj.movementitemuomId,
      cost: obj.item.standardpurchaseunitprice,
      itmqty:obj.quantity 
    }; 
  }); 
}

const NewDoorFastQuote = (props) => {
  const navigate = useNavigate();
  var newDate = new Date()
  var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear();  
  let params = useParams();

  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');

  const [materialbrands, setMaterialbrands] = useState([]);
  const [materialcolors, setMaterialcolors] = useState([]);
  const [materialbrand, setMaterialBrand] = useState({});
  const [materialcolor, setMaterialColor] = useState({});  

  const [raisedbyuser, setraisedbyuser] = useState('');
  const [job, setJob] = useState({});
  const [duedate, setDuedate] = useState('');
  const [raiseddate, setRaiseddate] = useState('');

  const [specialnotes, setSpecialnotes] = useState('');
  const [jobs, setJobs] = useState('');
  const [versionid, setVersionId] = useState(null);
  const [addeditems,setAddeditems] = useState([]); // addeddoors

  const [delivery, setDelivery] = useState(0);
  const [distance, setDistance] = useState(0);
  const [calcs, setCalcs] = useState({});
  const [versiondoordetail, setVersionDoorDetail] = useState({});
  const [totalDoorCalculation, setTotalDoorCalculation] = useState(0);
  const [totalHingeBoreCost, setTotalHingeBoreCost] = useState(0);

  /* BEGIN PARAMETERS*/
  const [packaging_cost_door_q4_param, setpackaging_cost_door_q4_param] = useState(null);
  const [surcharge_per_order, setsurcharge_per_order] = useState(null);
  /*
  const [processing_routing_sqft, setprocessing_routing_sqft] = useState(null);
  const [processing_eb_sqft, setprocessing_eb_sqft] = useState(null);
  const [processing_assembly_sqft, setprocessing_assembly_sqft] = useState(null);
  const [sqft_markup_cq, setsqft_markup_cq] = useState(null);
  */
  /**END PARAMETERS */

  //const { user: currentUser } = useSelector((state) => state.auth);
  //const [users, setUsers] = useState('');
  const user = props.user; // not needed
  const [item, setItem] = useState([]);
  const [totalmovement, setTotalmovement] = useState(0);

  const [editdr, seteditdr] = useState({});  
  const [fastQuoteDoor, setFastQuoteDoor] = useState({});
  const [mode, setMode] = useState(props.mode);
  const [userRoles, setUserRoles] = useState([]);    
  const [show, setShow] = useState(false);

  /*
  const producttypes = producttypes;
  const doorstyles = doorstyles;
  */

  const handleClose = () => setShow(false);
  const handleShow = () => {
    console.log(editdr);
    setShow(true);
  };  

  const handleValidations = () => {
    onchangeMode();
  }  

  const doorsArrayFunction = (doors, door) => {
    console.log(doors);
    console.log(door);
    setAddeditems([...doors, door]);
  }  

  const onChangeJob = (e) => {
    let jobId = parseInt(e.target.value);
    console.log(jobId);
    console.log(jobs);
    setJob(jobs.find(obj => obj.id === jobId) || {});   
  }

  const onChangeSpecialNotes = (e) => {
    setSpecialnotes(e.target.value);
  }

  const onChangeDelivery = (e) => {
    setDelivery(e.target.value);
  }    
  
  const onChangeDistance = (e) => {
    setDistance(e.target.value);
  }   
  
  const onChangeMaterialBrand = (e) => {
    setMaterialBrand(materialbrands.find(item => item.id === parseInt(e.target.value))); 
  }
  
  const onChangeMaterialColor = (e) => {
    setMaterialColor(materialcolors.find(item => item.id === parseInt(e.target.value)));
  }  

  /** BEGIN PARAMETERS */
  
  const onChangepackaging_cost_door_q3_param = (e) => {
    setpackaging_cost_door_q4_param(e.target.value);
  }
  
  const onChangesurcharge_per_order = (e) => {
    setsurcharge_per_order(e.target.value);
  }  
  
  /* END PARAMETERS*/

  const onChangeDueDate = (e) => {    
    //let localDate = new Date(e.target.valueAsNumber);
    //const now_utc = new Date(localDate.toUTCString().slice(0, -4));
    //console.log(now_utc.toString()); // ignore the timezone
    //let utcdDate = Date.UTC(localDate.getUTCFullYear(), localDate.getUTCMonth(),
    //localDate.getUTCDate(), localDate.getUTCHours(),
    //localDate.getUTCMinutes(), localDate.getUTCSeconds());
    //setDuedate(e.target.value);  
    //console.log(utcdDate);
    //setDuedate(now_utc.toString());      
    setDuedate(new Date(dtFormatter(e.target.valueAsNumber,3)).valueOf());
  }  

  const onJobSelected = (idSelVal, descSelVal, otherVal, otherVal2,otherVal3) => {    
    setJob({
      id: parseInt(idSelVal),
      jobtitle: descSelVal,
      jobdescription: otherVal,
      clientId: otherVal2,
      clientname: otherVal3
    });
  }   

  const retrieveJobs = () => {
    JobDataService.getAll()
      .then(response => {
        setJobs(response.data);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  }   

  const handleValidationAdd = () => {
    // add validations here
    //
    onAddItem(item);
  }

  const removeItem = (index) => {    
    setAddeditems(addeditems.filter((addeditem, i) => {
      return i !== index
    }));
    console.log(addeditems);
  }

  const editItem = (i, data) => {
    console.log("index");
    console.log(i);
    console.log(data);
    console.log(addeditems);
    setAddeditems(prevItems =>
      prevItems.map((currentItem, index) =>
        index === i ? data : currentItem
      )
    );

    

  }

  const onAddItem = (new_item) => {
    console.log(new_item);
    setAddeditems([...addeditems, new_item]);        
    setItem([]); 
    console.log(new_item);
  }  

  useEffect(() => {
    setMaterialBrand(materialbrands.find(obj => parseInt(obj.id) === parseInt(editdr.brandId)) || {});     
  },[materialbrands]);  

  useEffect(() => {
    setMaterialColor(materialcolors.find(obj => parseInt(obj.id) === parseInt(editdr.colorId)) || {});     
  },[materialcolors]);  

  useEffect(() => {
    console.log(materialbrand);
    MaterialColorsDataService.getByMaterialBrand(materialbrand.id)
    .then(resp => {
      console.log(resp.data);
      setMaterialcolors(resp.data);
    })
    .catch(err => {
      console.log(err);
    });       
  },[materialbrand]);  

  useEffect (() => {
    retrieveJobs();
    if (mode === 0) {
      setraisedbyuser(props.user);
    }
    else {
      setDuedate(new Date(duedate).valueOf());
    }
    if (props.user) {
      getUserRoles(props.user.id).then(resp => {
        console.log(resp);
        setUserRoles(resp);
      });
    }

  },[props.user])

  useEffect (() => {
    console.log(item);
  },[item]);

  useEffect(() => {
    /*
    setFinishCabinet(finishcabinets.find(obj => parseInt(obj.id) == parseInt(editdr.finishcabinet)) || {});        
    setFinishCabinetDoor(finishcabinetdoors.find(obj => parseInt(obj.id) == parseInt(editdr.finishcabinetdoor)) || {});   
    //setBaseCabinets(editdr.baseCabinets); it doesn't work
    */
  },[editdr]);

  useEffect (() => {    
    console.log(mode); 
    console.log(editdr);
    console.log(Object.keys(editdr).length > 0);

    MaterialBrandsDataService.getAll()
    .then(resp => {
      console.log(resp.data);
      setMaterialbrands(resp.data);
    })
    .catch(err => {
      console.log(err);
    });  

    if (mode === 0) { // create
      setraisedbyuser(props.user);
      setRaiseddate(dtFormatter(new Date(),1));
      seteditdr({empty:true});  
      setMaterialColor({}); 

    }  
    else { // view or edit
      
      FastQuotingDoorVersionsDataService.findById(params.id)      
      .then((response) => {
        var respdata = response.data;
        console.log(respdata);
        setraisedbyuser(respdata.user);
        setRaiseddate(dtFormatter(new Date(respdata.createdAt),2));
        seteditdr(respdata);    
        setJob(respdata.fastquotingdoor.job);   
        setDuedate(new Date(respdata.duedate).valueOf());
        console.log(dtForInputDate(duedate));
        setFastQuoteDoor(respdata.fastquotingdoor);
        //setBaseCabinets(respdata.baseCabinets); it doesn't work
        setCalcs({
          surcharge: respdata.surcharge,
          packing: respdata.packing,
          hingeborring: 0,
          delivery_cost: respdata.delivery_cost,
          version_totaldoorquote: respdata.surcharge + respdata.packing + respdata.delivery_cost
        });
        setTotalDoorCalculation(
          respdata.versiondoordetail.reduce((sum, item) => {
            const price = item.doorcalculation?.[0]?.total_price_door ?? 0;
            return sum + price;
          }, 0)
        );
        setTotalHingeBoreCost(
          respdata.versiondoordetail.reduce((sum, item) => {
            const hingeprice = item.doorcalculation?.[0]?.hinge_bore_cost ?? 0;
            return sum + hingeprice;
          }, 0)
        );             
        //setMaterialBrand({id:10});
        setVersionDoorDetail(respdata.versiondoordetail);
        const versiondoordetail = respdata.versiondoordetail;
        console.log(producttypes);
        console.log(versiondoordetail);
        
        const newArrayItems = versiondoordetail.map(obj => {
          // Check if the object has the key you want to replace
          if (obj.hasOwnProperty('producttype')) {
            let ptype = producttypes.find(ptype => parseInt(ptype.id) === parseInt(obj.producttype));
            let dstyle = doorstyles.find(dstyle => parseInt(dstyle.id) === parseInt(obj.doorstyle));
            console.log(ptype);
            console.log(dstyle);
            // Create a new object with the updated key-value pair using spread syntax
            return { ...obj, producttype: ptype , doorstyle: dstyle}; 
          }
          // If the key is not present, return the original object
          return obj;
        })
        //setAddeditems(respdata.versiondoordetail);
        setAddeditems(newArrayItems);
        setpackaging_cost_door_q4_param(respdata.packaging_cost_door_q4_param);
        setsurcharge_per_order(respdata.surcharge_per_order);
      })
      .catch((error) => {
        console.log(error);
      });  
             
    }      
  },[])  

  const handleSave = () => {
    if (Object.keys(job).length === 0) { //
      setShowerror(true);
      setErrmessage('Job not selected!')
      return;
    }  
    
    if (Object.keys(addeditems).length === 0) { //
      setShowerror(true);
      setErrmessage('Doors not added!')
      return;
    }    
    
    if (delivery === 1 && (distance === null || distance === undefined)) {
      setShowerror(true);
      setErrmessage('Please, specify a distance.')
      return;      
    }
  
    if (mode === 0) { // create first version
      // fast quoting door
      var data = {
        userId: raisedbyuser.id,
        jobId: parseInt(job.id),
        duedate: duedate,
        fastquotingdoorstatus:1,      
      };
      console.log(data);      
      
      FastQuotingDoorDataService.create(data)      
      .then(response => {   
        console.log(data);
        var dataupdate = {
          fastquotingdoornumber: 'FQDoor-' + response.data.id.toString().padStart(5,'0')
        };
        FastQuotingDoorDataService.update(response.data.id, dataupdate)          
        .then(() => {
          handleSaveVersion(response.data.id, mode);        
        })
        .catch((err) => {
          console.log(err);
        })
        
      })      
      .catch(e => {
        console.log(e);        
        setShowsuccess(false);
        setSuccmessage('');
        setShowerror(true);
        setErrmessage(e.response?e.response.data.message:e.message)        
        //console.log(e.response.status === 401);
        if (e.response.status === 401) {
          window.location.reload();
        }
      }); 
      
    }
    else if (mode === 1) { // edit this quote version
      
      var data = {
        jobId: parseInt(job.id)
      };
      
      FastQuotingDoorDataService.update(editdr.fastquotingdoorId, data)      
      .then(() => {   
        handleSaveVersion(editdr.fastquotingdoorId, mode);        
      })      
      .catch(e => {
        console.log(e);        
        setShowsuccess(false);
        setSuccmessage('');
        setShowerror(true);
        setErrmessage(e.response?e.response.data.message:e.message)        
        //console.log(e.response.status === 401);
        if (e.response.status === 401) {
          window.location.reload();
        }
      });       
    }    
  }

  const handleSaveVersion = async (fastquotingdoorId, mode) => {

    const updatedItems = addeditems.map(obj => {
      return { ...obj, brand: materialbrand, color: materialcolor };
    });

    var data = {
      fastquotingdoorId: fastquotingdoorId,
      delivery: delivery,
      distance: distance,
      userId: raisedbyuser.id,
      comments: specialnotes,
      doors: updatedItems, //addeditems,
      brandId: materialbrand.id,
      colorId: materialcolor.id
    }

    console.log(data);
    if (mode === 0) { // create
      data.versionnumber = 1;
      FastQuotingDoorVersionsDataService.create(data)
      .then(async response => {          
        console.log(response.data);
        if (response.data.calcs) {
          setVersionId(response.data.calcs.versionid);
        }        
        setShowsuccess(true);
        setSuccmessage('Fast Quoting Door has been created successfully.');
        setShowerror(false);
        setErrmessage('');  
      })  
      .catch(e => {
        console.log(e);
        setShowsuccess(false);
        setSuccmessage('');
        setShowerror(true);
        setErrmessage(e.response?e.response.data.message:e.message);                  
      })       
    }
    else if (mode === 1) {
      // copy parameters of this quote
      var data_params = {
        packaging_cost_door_q4_param: packaging_cost_door_q4_param,
        surcharge_per_order: surcharge_per_order,
        /*
        processing_routing_sqft: 5,//processing_routing_sqft,
        processing_eb_sqft: processing_eb_sqft,
        processing_assembly_sqft: processing_assembly_sqft,
        sqft_markup_cq: sqft_markup_cq
        */
      }
      Object.assign(data, data_params);
      console.log(data);
      setVersionId(editdr.id);

      FastQuotingDoorVersionsDataService.update(editdr.id, data)
      .then(response => {          
        console.log(response.data);
        setCalcs(response.data.calcs);
        setShowsuccess(true);
        setSuccmessage('Fast Quoting Doors has been updated successfully.');
        setShowerror(false);
        setErrmessage('');                
      })  
      .catch(e => {
        setShowsuccess(false);
        setSuccmessage('');
        setShowerror(true);
        setErrmessage(e.response?e.response.data.message:e.message);                  
      });    
    }
    

  }

  const handleSaveVersionDoorDetail = async (versiondoordetail) => {





  }

  const onchangeMode = () => {
    console.log("running change mode");
    console.log(mode);
    if (mode === 1) {
      setMode(2);
      // confirm cancel edition
      // not needed now I would say...

      // change everything back
      onCancelEditionConfirmed();
    }
    else if (mode === 2 ) {
      setMode(1);
      console.log(editdr);
      setDelivery(editdr.delivery);
      setDistance(editdr.distance);
      setJob(editdr.fastquotingdoor.job);

    }    
  }

  const onCancelEditionConfirmed = () => {
    setraisedbyuser(editdr.user);
    setRaiseddate(dtFormatter(new Date(editdr.createdAt),2));
    setJob(editdr.fastquotingdoor.job);        //id
    setDuedate(new Date(editdr.duedate).valueOf());
    console.log(dtForInputDate(duedate));
  }  

  return (
    <>
      <Container style={{width:"80%"}}>
        <PageHeader />

        <Row style={{position:'sticky',top:'50px',backgroundColor:'white',zIndex:'10'}}> 
          <h4 className='mb-2' style={{width: "100%", textAlign: "left", marginLeft: "0%", color: "green" }}>
            {mode === 0 && "New Door Fast Quote"}
            {mode === 1 && editdr && "Door Fast Quote " + fastQuoteDoor.fastquotingdoornumber + "," + " version: " + ((editdr.versionnumber)?editdr.versionnumber:"").padStart(5,"0")}
            {mode === 2 && editdr && "Door Fast Quote " + fastQuoteDoor.fastquotingdoornumber + "," + " version: " + ((editdr.versionnumber)?editdr.versionnumber:"").padStart(5,"0")}
          </h4>                
          <Col>     
            {<><Button style={{width:"100%"}} onClick={handleSave} disabled={mode===2}>Save This Version</Button></>}         
          </Col>
          {(mode !== 0) && ([3,6].some(i => userRoles.includes(i))) && 
            <>
            <Col>     
            {<><Button style={{width:"100%"}} onClick={handleValidations} disabled={mode===1}>Edit This Version</Button></>}               
            </Col>
            <Col>     
            {<><Button variant="danger" style={{width:"100%"}} onClick={handleShow} disabled={mode!==1}>View/Edit Parameters</Button></>}               
            </Col>            
            </>
          }
          <Col style={{textAlign:'right'}}>
            <FormLabel htmlFor="job">Total Quote:</FormLabel>  
          </Col>          
          
          <Col>     
            <Row className='row-md-3' sm={8}>
              
              <div style={{display:"flex"}}>
                <FormControl className="form-control mb-3"
                  disabled={true}
                  type="text"
                  name="totalquoteversion"
                  id="totalquoteversion"
                  value={usdCurrencyFormat(calcs.version_totaldoorquote?calcs.version_totaldoorquote+totalDoorCalculation+totalHingeBoreCost:0)} 
                />
              </div>                
            </Row>                
          </Col>          
          <hr/>
        </Row> 

        <Container>

          <Row className='mt-2' >
            <Col className='col-md-3' sm={8}>
              <FormLabel htmlFor="todaydate">Raised Date:</FormLabel>
              <FormControl className="form-control"
                defaultValue={raiseddate}
                type="text"
                name="todaydate"
                disabled
                id="todaydate" />
            </Col>
            <Col className='col-md-3' sm={8}>
              <FormLabel className="mr-5" htmlFor="raisedby">Raised By:</FormLabel>
              <FormControl className="form-control"
                defaultValue= {raisedbyuser?raisedbyuser.username:null} ////////////////////////////////////////////////////////////////////////////////
                type="text"
                name="raisedby"
                disabled
                id="raisedby" />
            </Col>

            <Col className='col-md-3' sm={8}>
              <FormLabel className="mr-5" htmlFor="raisedbyemail">Raised By Email:</FormLabel>
              <FormControl className="form-control"
                defaultValue={raisedbyuser?raisedbyuser.email:null}
                type="text"
                name="raisedbyemail"
                disabled
                id="raisedbyemail" />
            </Col>

            <Col className='col-md-3' sm={8}>
              <FormLabel className="mr-5" htmlFor="tel">Raised By Telephone:</FormLabel>
              <FormControl className="form-control mb-3"
                disabled={mode === 2}
                type="text"
                name="tel"
                id="tel" 
              />
            </Col>

            <Col className='col-md-3' sm={8} >
              <FormLabel className="mr-5" htmlFor="job">Job:</FormLabel>
              <div style={{display:"flex"}}>
              <select value={job?job.id:editdr.fastquotingdoor.job.id} onChange={onChangeJob} className="form-control" id="job" name="job" disabled={mode===2}>
                <ListOfJobs jobs={jobs}/>       
              </select>

              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
              >        
                <SearchJob onSelected={onJobSelected} disabled={mode===2}/>    
              </OverlayTrigger> 
              </div>
            </Col>

            <Col className='col-md-3' sm={8}>
              <FormLabel className="mr-5" htmlFor="duedate">Due Date:</FormLabel>
              <FormControl
                disabled={mode === 2}
                className="form-control" 
                onChange={onChangeDueDate} 
                id="duedate" 
                type="date" 
                data-date="" 
                data-date-format="DD-MM-YYYY" 
                value={mode===0?null:dtForInputDate(duedate)}
              />
            </Col>           

          </Row>

          <Row className='mt-4' >
            <Col className='col-md-4' sm={8}>
              <FormLabel className="mr-5" htmlFor="notes">Special Notes:</FormLabel>
              <FormControl className="form-control mb-3"
                disabled={mode===2}
                onChange={onChangeSpecialNotes}
                as="textarea"
                rows="5"
                type="text"
                name="notes"
                id="notes" 
                defaultValue={mode===0?null:editdr.specialnotes}
              />    
              
            </Col>  
          </Row>
          

  {/*///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////*/}
          <h4 className='mb-2' style={{width: "100%", marginLeft: "0%", color: "green" }}>Job Interview</h4>          
          <Row> 
            <Col className='card'>
              <FormLabel>DELIVERY:</FormLabel>
              <div style={{display:"flex"}}>
              <select onChange={onChangeDelivery} className="form-control" id="delivery" name="delivery" disabled={mode===2}>
                <option value={1} selected={!editdr.empty?editdr.delivery == 1:false}>Yes</option>      
                <option value={0} selected={!editdr.empty?editdr.delivery == 0:true}>No</option>      
              </select>
              </div>
              <FormLabel className='mt-2 form-control-sm'>Select YES or NO if needed.</FormLabel>
            </Col> 

            <Col className='card'>
              <FormLabel>Let us know roughly how many miles your jobsite is from Orange, CA (Max 450 miles):</FormLabel>
              <FormControl onChange={onChangeDistance} type="number" name="distance" id="distance" defaultValue={!editdr.empty?editdr.distance:0} disabled={mode===2 || delivery === 0}></FormControl>
            </Col>             
          </Row>

          <Row> 
            <Col className='card'>
              <FormLabel>Default Brand:</FormLabel>

              <div className="m-1">
                <select 
                  //defaultValue={!editdr.empty?editdr.brandId:0}
                  onChange={onChangeMaterialBrand} 
                  className="form-control" 
                  id="materialbrand" 
                  name="materialbrand" 
                  disabled={mode==2}>
                  <ListOfMaterialBrands materialbrands={materialbrands} materialbrand={materialbrand.id?materialbrand.id:-1}/>       
                </select>                 
              </div>                
            </Col> 

            <Col className='card'>
              <FormLabel>Default Color:</FormLabel>

              <div className="m-1">
                <select 
                  style={{minWidth:"400px"}} 
                  //defaultValue={materialcolor} 
                  onChange={onChangeMaterialColor} 
                  className="form-control" 
                  id="materialcolor" 
                  name="materialcolor" 
                  disabled={mode==2}>
                  <ListOfMaterialColors materialcolors={materialcolors} materialcolor={materialcolor.id?materialcolor.id:-1}/>       
                </select>                 
              </div>                  
            </Col>             
          </Row>          

          <Col className='md-3 card-container'  style={{position:'sticky',top:'150px',backgroundColor:'white',zIndex:'10'}}> 
          
            <NewEditDoor 
              mode={mode} 
              doorsmode={0}
              addeditems={addeditems} 


              doorsArrayFunction={doorsArrayFunction}
              producttypes={producttypes}
              doorstyles={doorstyles}

              setShowerror={setShowerror}
              setErrmessage={setErrmessage}

              materialbrand={materialbrand} // array
              materialcolor={materialcolor} // array              
            />
              
            
          

          {/*}  <Button onClick={handleValidationAdd}>New Door</Button>                */}
            <hr/>   
            <h4 className='mb-2' style={{width: "100%", marginLeft: "0%", color: "green" }}>Added Doors</h4>          

            <DoorsList 
              doorstyles={doorstyles}
              producttypes={producttypes} 
              listOfDoors={addeditems} 
              doorsArrayFunction={doorsArrayFunction}
              removeItem={removeItem} 
              editItem={editItem} 
              setShowerror={setShowerror}
              setErrmessage={setErrmessage}              
              mode={mode}/>


          </Col>     

          <Row className='mt-2'>

            {showerror && (
              <MessageBox show={true} showerror={showerror} errmessage={errmessage}
                onHide={() => {
                  setShowerror(false)
                }}
              />
            )}
            {showsuccess && (

              <MessageBox show={true} showsuccess={showsuccess} succmessage={succmessage}
                onHide={() => {
                setShowsuccess(false);
                navigate('/view-door-fast-quoting/' + versionid);
                window.location.reload();
                //window.location.assign('');
              }}
              />
            )}
            <hr/>    
          </Row>                        
          <br></br>
        </Container>   
      </Container>         
    </>
  )  
}

const ListOfDoors = (props) => {

}


const ListOfJobs = (props) => {
  if (!props.jobs) {
    return 
  }
  const rows = props.jobs.map((row, index) => {
    return (  
      <option key={index} value={row.id}>        
        {row.jobtitle}
      </option>
    )
  })  
  return (      
    <>        
    <option disabled selected>
      {"Select"}
    </option>
    {rows}
    </>
  )
}

const ListOfMaterialBrands = (props) => {
  if (!props.materialbrands) {
    return 
  }
  const rows = props.materialbrands.map((row, index) => {
    return (  
      <option key={index} value={row.id} selected={props.materialbrand == row.id}>        
        {row.materialbrandname}
      </option>
    )
  })  
  return (      
    <>        
    <option disabled value={-1} selected={props.materialbrand == -1}>
      {"Select"}
    </option>
    {rows}
    </>
  )
}

const ListOfMaterialColors = (props) => {
  if (!props.materialcolors) {
    return 
  }
  const rows = props.materialcolors.map((row, index) => {
    return (  
      <option key={index} value={row.id} selected={props.materialcolor == row.id}>        
        {row.materialcolorname}
      </option>
    )
  })  
  return (      
    <>       
    <option disabled value={-1} selected={props.materialcolor == -1}>
      {"Select"}
    </option>
    {rows}
    </>
  )
}  



export default NewDoorFastQuote;
